import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";

export class memberBenefits {
	private memberBase:any = new memberPortal();
	dataUrl:any;
	initTables(): any {
		let _self = this;
		let benefitsTable = $('#members--benefits table');
		let tableOptions = {
			"processing" : true,
			"ajax" : {
				"url" : '/bin/services/new/getBenefitsLCPAPI',
				dataSrc : '',
                cache: true
			},
			"columns": [
				{ "data": "issuedate" },
				{ "data": "vouchername" },
				{ "data": "partnername" },
				{ "data": "expirydate" },
				{ "data": "status" }
			],
			"columnDefs": [
			  { "width": "250px", "targets": 1 }
			]	
		  }
		benefitsTable.dataTable(tableOptions);
	}
}

let scope:Element = document.querySelector('#members--benefits');

if (scope) {
	try {
	let memberBenefit = new memberBenefits();
	let url;
    $(document).ready(function() {
       /* if (window.location.hostname === 'localhost') {
            url = '/bin/services/new/getBenefitsLCPAPI';
           }*/
      // else {
          url = '/bin/services/new/getBenefitsLCPAPI'; // yet to decide
       //}
    });
    memberBenefit.dataUrl = url;
	memberBenefit.initTables();
	} catch(e) {console.error(e);}
}
